import type { ReactNode } from "react";
import { ProjectEditingContext, type ProjectEditingContextValue } from "./projectEditingContext.ts";

/**
 * Wraps EditBar.tsx (see App.tsx) so it and its editor-only tabs
 * (SubBasinsPanel, OutletPointsPanel, AquifersPanel, SeriesPanel,
 * GenericLayersPanel) can read the stable project-data slice with
 * `useProjectEditing()` instead of each receiving it as its own explicit
 * props — previously, adding one new field to that slice meant editing
 * App.tsx, EditBar.tsx's signature AND JSX pass-through, and the leaf
 * panel's signature; now only App.tsx (this Provider's `value`) and the one
 * leaf panel that actually needs the new field.
 *
 * Step2Zones.tsx (the "zones" tab) deliberately stays OUTSIDE this — it's
 * shared with the new-project wizard, which has no ProjectEditingProvider
 * above it (there's no already-open project to edit yet), so it keeps
 * receiving `project`/`gisLayer`/`onChange` as explicit props; EditBar.tsx
 * reads those from context itself and forwards them the old way, just for
 * that one tab.
 */
export function ProjectEditingProvider({
  value,
  children,
}: {
  value: ProjectEditingContextValue;
  children: ReactNode;
}) {
  return <ProjectEditingContext.Provider value={value}>{children}</ProjectEditingContext.Provider>;
}
